import { render, staticRenderFns } from "./AllInOneLegalCard.vue?vue&type=template&id=16b4da73&"
import script from "./AllInOneLegalCard.vue?vue&type=script&lang=js&"
export * from "./AllInOneLegalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports